import React, { forwardRef } from "react";
import { type ContentComponentElement } from "../types";
import { type UseComponentDataArgs } from "../hooks/useComponentData";
import { compareComponent, compareContent } from "../helpers/comparers";

function componentCompareFunction<TExtraProperties = {}>(
  prevProps: UseComponentDataArgs & TExtraProperties,
  nextProps: UseComponentDataArgs & TExtraProperties
): boolean {
  const prevExtraProps = (
    Object.keys(prevProps) as [keyof typeof prevProps]
  ).filter((key) => key !== "component" && key !== "context");
  const nextExtraProps = (
    Object.keys(nextProps) as [keyof typeof nextProps]
  ).filter((key) => key !== "component" && key !== "context");
  if (prevExtraProps.length !== nextExtraProps.length) {
    console.log("ExtraProps length createComponentElement changed.");
    return false;
  }
  for (const key of prevExtraProps.filter(
    (s) => s.toString() !== "componentRef"
  )) {
    if (prevProps[key] !== nextProps[key]) {
      console.log(
        `ExtraProp ${key.toString()} createComponentElement changed.`
      );
      return false;
    }
  }
  const componentEqual = compareComponent(
    prevProps.component,
    nextProps.component
  );
  if (!componentEqual) {
    console.log("Component props createComponentElement changed.");
    return false;
  }

  const contentEqual = compareContent(prevProps.context, nextProps.context);
  if (!contentEqual) {
    console.log("Context props createComponentElement changed.");
    return false;
  }

  return true;
}

export function createComponentElement<TExtraProperties = {}>(
  component: ContentComponentElement<TExtraProperties>
) {
  return React.memo(forwardRef(component), componentCompareFunction);
}
